import ui from '@/interface/ui/events/[id]';
export default ui;
